// import Headings from "../../src/utils/csvHeadings.utils";
import { CommonCsvFunctions } from "./commonCsvFunctions.mixin";
import { mapState, mapActions } from "vuex";
export const ProductCsv = {
	mixins: [CommonCsvFunctions],
	data() {
		return {
			// nullArray: []
			Headings: [
				"Item Name",
				"Item Code",
				"Item Type",
				"Order Unit",
				"Contains",
				"Base Unit"
			],
			errorsInCsv: []
		};
	},
	methods: {
		processProductCsv(chunk) {
			// debugger;
			console.log("chunk", chunk);
			// var result = {};
			if (!chunk.errors.length) {
				const headings = chunk.meta.fields;
				const status = this.checkHeadingsEquality(this.Headings, headings);
				// console.log("status", status);
				if (!status) {
					console.log(this.Headings, headings);
					this.addError({
						row: 1,
						column: "",
						details: `Headings should be as following: ${this.Headings}`
					});
					// this.$notify.error({
					// 	title: "Fail",
					// 	dangerouslyUseHTMLString: true,
					// 	message: `<p>The Headings should be as following.</p><ul>${Headings.productCsv
					// 		.map(item => `<li>${item}</li>`)
					// 		.join("")}</ul>`,
					// 	duration: 0
					// });
					// return false; // validation not complete
				}
				if (status) {
					// console.log("inside status true");
					// result.headings = Headings.productCsv.map(heading => {
					// 	return {
					// 		value: heading,
					// 		isError: false,
					// 		colspan: 1
					// 	};
					// });
					const data = chunk.data;
					// console.log("data", data);

					data.map((row, rowIndex) => {
						// console.log("row in map", row);
						// console.log("row", row);
						this.getModifiedProRow(row, rowIndex);
					});
				}
			}
			// return result;
			// return true; // validation complete
		},

		getModifiedProRow(row, rowIndex) {
			// console.log("row in getmodifiedrow", rowIndex);
			// const modifiedRow = {};
			/*A 	Item Code */
			if (row.hasOwnProperty("Item Name")) {
				this.validateItemName(row["Item Name"], rowIndex);
			}

			if (row.hasOwnProperty("Item Code")) {
				this.validateItemCode(row["Item Code"], rowIndex);
			}

			if (row.hasOwnProperty("Item Type")) {
				this.validateItemType(row["Item Type"], rowIndex);
			}

			if (row.hasOwnProperty("Order Unit")) {
				this.validateOrderUnit(row["Order Unit"], rowIndex);
			}

			if (row.hasOwnProperty("Contains")) {
				this.validateContains(row["Contains"], rowIndex);
			}

			if (row.hasOwnProperty("Base Unit")) {
				this.validateBaseUnit(row["Base Unit"], rowIndex);
			}
		},
		validateBaseUnit(baseUnit, rowIndex) {
			if (!baseUnit) {
				if (!this.checkForNumber(baseUnit)) {
					this.addError({
						row: rowIndex + 2,
						column: "Base Unit",
						details: "value can't be empty"
					});
				}
			}

			if (baseUnit && !this.checkForNumber(baseUnit)) {
				this.addError({
					row: rowIndex + 2,
					column: "Base Unit",
					details: "value should be a Number"
				});
			}
		},
		validateContains(Contains, rowIndex) {
			if (!Contains) {
				this.addError({
					row: rowIndex + 2,
					column: "Contains",
					details: "if empty there shall be 0"
				});

				if (
					!this.checkForNumber(Contains) ||
					this.checkIfDecimalNumber(Contains) ||
					Contains < 0
				) {
					this.addError({
						row: rowIndex + 2,
						column: "Contains",
						details: "value should be a Integer number"
					});
				}
			}
		},
		validateOrderUnit(orderUnit, rowIndex) {
			if (!orderUnit) {
				this.addError({
					row: rowIndex + 2,
					column: "Order Unit",
					details: "value can't be empty"
				});
			}
			if (
				!this.checkForNumber(orderUnit) ||
				this.checkIfDecimalNumber(orderUnit)
			) {
				this.addError({
					row: rowIndex + 2,
					column: "Order Unit",
					details: "value should be a Integer number"
				});
			}
		},
		validateItemType(itemType, rowIndex) {
			if (itemType) {
				// const lowerCaseVal = itemType.toLowerCase();
				// if (!itemTypeValues.some(val => lowerCaseVal == val)) {
				if (!this.checkForString(itemType)) {
					this.addError({
						row: rowIndex + 2,
						column: "Item Type",
						details: `value should be one of String`
					});
				}
				// }
			}
			if (!itemType) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Type",
					details: "value can't be empty"
				});
			}
		},
		validateItemCode(itemCode, rowIndex) {
			// console.log("itemCode", itemCode);
			// const uniqueProductCodeValue = String(itemCode).hashCode();

			if (itemCode) {
				if (!this.checkForAlphaNumeric(itemCode)) {
					this.addError({
						row: rowIndex + 2,
						column: "Item Code",
						details: "value not alpha numeric"
					});
					// this.pushError(particularRowObject, "value not alpha numeric");
				}
				// if (!this.checkForUniqueInt(itemCode)) {
				// 	this.addError({
				// 		row: rowIndex + 2,
				// 		column: "Item Code",
				// 		details: "value not unique"
				// 	});
				// }
			}
			if (!itemCode) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Code",
					details: "value can't be empty"
				});
				// this.pushError(particularRowObject, "value can't be empty");
			}
			// if (!particularRowObject.isError) particularRowObject.details = [];
		},
		validateItemName(itemName, rowIndex) {
			// particularRowObject.isError = false;
			if (itemName) {
				if (!this.checkForString(itemName)) {
					this.addError({
						row: rowIndex + 2,
						column: "Item Name",
						details: "value not string"
					});
					// this.pushError(particularRowObject, `value not string`);
				}
			}
			if (!itemName) {
				this.addError({
					row: rowIndex + 2,
					column: "Item Name",
					details: "value can't be empty"
				});
				// this.pushError(particularRowObject, "value can't be empty");
			}
		}
	}
};
